// extracted by mini-css-extract-plugin
module.exports = {"hotelDescription":"hotel_info_section_hotelDescription__QbgoN","hotelTitleSection":"hotel_info_section_hotelTitleSection__crgch"};